

































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import * as SharedRoutes from "@/shared/route-names";
import Activity from "@/shared/components/investments/drivewealth/Activity.vue";
import ManagedTransfersActivity from "@/shared/components/investments/drivewealth/ManagedTransfersActivity.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DayTradeListing from "@/shared/components/investments/drivewealth/DayTradeListing.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useUserStore } from "@/shared/store/user";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    Activity,
    DrivewealthNavigation,
    DayTradeListing,
    RiskDisclaimer,
    ManagedTransfersActivity,
    GenericLoadingSpinner,
    AccountTypeSubheader
  }
})
export default class ActivityPage extends Vue {
  userStore = useUserStore();
  drivewealthStore = useDrivewealthStore();

  @Prop() routeToPages: (page: number) => Location;
  @Prop() routeToDrivewealthActivity: (pageNumber: number) => undefined;
  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop() isHistory: boolean;
  @Prop() isTransfers: boolean;
  @Prop() accountId: number;

  mounted (): void {
    this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
  }

  get managedTransferPageNumber () {
    return this.getNumberFromQuery(this.$route.query.transfers);
  }

  get activityTransferPageNumber () {
    return this.getNumberFromQuery(this.$route.query.transactions);
  }

  getNumberFromQuery (query): number {
    if (typeof query === "string") {
      return parseInt(query) || 1;
    } else if (typeof query === "number") {
      return query;
    }
    return 1;
  }

  onManagedTransferPageChanged (pageNumber: number) {
    this.onPageChanged(pageNumber, this.activityTransferPageNumber);
  }

  onActivityPageChanged (pageNumber: number) {
    this.onPageChanged(this.managedTransferPageNumber, pageNumber);
  }

  onPageChanged (transfers: number, transactions: number) {
    const targetRoute: any = {
      name: this.$route.name,
      params: {},
      query: {
        transfers,
        transactions
      }
    };

    if (this.username) {
      targetRoute.query.username = this.username;
    }
    if (this.partnerId) {
      targetRoute.params.partnerId = this.partnerId;
    }
    if (this.accountId) {
      targetRoute.params.accountId = this.accountId;
    }
    this.$router.push(targetRoute);
  }

  get navItems () {
    const query = (this.username) ? { username: this.username } : undefined;
    const items = new Map<Location, string>();
    items.set({
      name: SharedRoutes.DrivewealthInvestmentActivityTransfersV2,
      params: { accountId: `${this.accountId}` },
      query
    }, "Transfers");
    items.set({
      name: SharedRoutes.DrivewealthInvestmentActivityHistoryV2,
      params: { accountId: `${this.accountId}` },
      query
    }, "Transaction History");


    return items;
  }

  get indexOfCurrentTab () {
    return Array.from(this.navItems.keys()).findIndex(i => i.name === this.$route.name);
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }
}
